import BaseRepository from "~/api/BaseRepository";
import type { $Fetch } from "nitropack";

export const CompanySizeRepository = (client: $Fetch) => ({
    ...BaseRepository(client)('v2/company-sizes'),
});